module.exports = __webpack_public_path__ + "static/023.thumb-0d007cf1762701dc4cc8c544b6021fe4.jpg";